import { v4 as uuidv4 } from 'uuid';
import {EndpointRank } from '../../../sdk/Alg/chat-constants';
import { ConversationStatus } from '../../../sdk/Alg/conversation-status-constants';

export class ConversationModel {
  _id?: any;
  uuid: string;
  revision: string;
  status: string;
  vrsn: string;
  conversation_type: string;
  channel: string;
  channel_chat_id: string;
  create_date: Date;
  update_date: Date;
  title: string;
  unread_messages: number;
  conversation_status: string;
  endpoint_participants: EndpointParticipant[];
  active_session: boolean;
  preferred_qr_code?: string;
  assign_date?: Date;
  agent_participants?: AgentParticipant[];
  agent_participants_outbound?: AgentParticipant[];
  created_by: string;
  updated_by: string;
  action?: Action;
  guid?: string;
  provider?: string;
  current_task_guid?: string;
  current_outbound_task_guid?: string;
  conversation_state?: string;

  constructor(userGuid: string, vcGuid: string, userName: string, vcName: string, chatId: string, channel: string, title: string){
    this.uuid = uuidv4();
    this.revision = uuidv4();
    this.status = "ACTIVE";
    this.conversation_status = ConversationStatus.Open;
    this.conversation_type = "PRIVATE";
    this.channel = channel;
    this.channel_chat_id = chatId;
    this.create_date = new Date();
    this.update_date = new Date();
    this.title = title;
    this.unread_messages = 0;
    this.active_session = false;

    const userParticipant: EndpointParticipant = {
      uuid: userGuid,
      rank: EndpointRank.owner,
      name: userName
    };

    const endpointParticipant: EndpointParticipant = {
      uuid: vcGuid,
      rank: EndpointRank.virtual,
      name: vcName
    };

    this.endpoint_participants = [userParticipant, endpointParticipant];
  }

}

export class EndpointParticipant {
  uuid: string;
  rank: string;
  name: string;
}
// ** Deprecation Warning ** guid is deprecated and will be removed soon
export class AgentParticipant {
  guid?: string;
  type: string;
  assignee_guid?: string; // can store either login_subject_guid (agent) or app_mst_grp_hdr_guid (team) 
}

export class Action {
  type: string;
  date: Date;
}
